(function () {
  const roots = document.querySelectorAll('[data-gcp-root]');
  if (!roots.length) return;
  const PREVIEW_STORAGE_PREFIX = 'gcPersonalizePreview:';
  const PREVIEW_TTL_MS = 6 * 60 * 60 * 1000;
  const PERSONALIZE_ORIGIN = 'https://personalize.at';
  const AUTO_OPEN_PARAM = 'gc_open_personalize';
  const AUTO_OPEN_TIMEOUT_MS = 10500;
  const PERSONALIZE_LOAD_TIMEOUT_MS = 12000;
  const PREVIEW_APPLIED_REFRESH_DELAYS = [90, 240];
  const PREVIEW_MODAL_CLOSE_REFRESH_DELAYS = [120, 360];
  const PREVIEW_CLEAR_REFRESH_DELAYS = [160, 420];
  const PREVIEW_STATE_SETTLE_MS = 1200;
  const PREVIEW_FOCUS_DELAY_MS = 260;
  const PREVIEW_FOCUS_FINE_TUNE_DELAY_MS = 220;
  const MAX_SHARED_GALLERY_MEDIA = 4;
  const PREVIEW_PROPERTY_KEY = '_gc_personalization_preview';
  const PERSONALIZATION_ID_PROPERTY_KEY = '_gc_personalization_id';
  const PERSONALIZATION_MODEL_PROPERTY_KEY = '_gc_personalization_model';
  const PERSONALIZATION_CASE_PROPERTY_KEY = '_gc_personalization_case';
  const ORIGINAL_MEDIA_EMPTY_VALUE = '__gcp_empty__';
  const MOBILE_PREVIEW_TOP_PADDING = 16;
  const MOBILE_PREVIEW_BOTTOM_PADDING = 20;

  const IPHONE_ORDER = [
    'iPhone 18 Pro Max', 'iPhone 18 Pro',
    'iPhone 17 Pro Max', 'iPhone 17 Pro', 'iPhone 17 Air', 'iPhone 17e', 'iPhone 17',
    'iPhone 16 Pro Max', 'iPhone 16 Pro', 'iPhone 16 Plus', 'iPhone 16', 'iPhone 16e',
    'iPhone 15 Pro Max', 'iPhone 15 Pro', 'iPhone 15 Plus', 'iPhone 15',
    'iPhone 14 Pro Max', 'iPhone 14 Pro', 'iPhone 14 Plus', 'iPhone 14',
    'iPhone 13 Pro Max', 'iPhone 13 Pro', 'iPhone 13', 'iPhone 13 Mini',
    'iPhone 12 Pro Max', 'iPhone 12 Pro', 'iPhone 12', 'iPhone 12 Mini',
    'iPhone 11 Pro Max', 'iPhone 11 Pro', 'iPhone 11',
    'iPhone XS Max', 'iPhone XS', 'iPhone XR', 'iPhone X',
    'iPhone 8 Plus', 'iPhone 8', 'iPhone 7 Plus', 'iPhone 7'
  ];
  const SAMSUNG_ORDER = [
    'Samsung Galaxy S26 Ultra', 'Samsung Galaxy S26 Plus', 'Samsung Galaxy S26', 'Samsung Galaxy S25 Ultra', 'Samsung Galaxy S25 Plus', 'Samsung Galaxy S25',
    'Samsung Galaxy S24 Ultra', 'Samsung Galaxy S24 Plus', 'Samsung Galaxy S24',
    'Samsung Galaxy S23 Ultra', 'Samsung Galaxy S23 Plus', 'Samsung Galaxy S23',
    'Samsung Galaxy S22 Ultra', 'Samsung Galaxy S22 Plus', 'Samsung Galaxy S22'
  ];

  roots.forEach((root) => {
    initRoot(root).catch(() => {
      const status = root.querySelector('[data-gcp-status-text]');
      if (status) {
        status.textContent = 'Case options are temporarily unavailable.';
        status.hidden = false;
      }
    });
  });

  warmPersonalizeOrigin();

  async function initRoot(root) {
    const config = parseJson(root.querySelector('[data-gcp-config]'));
    const currentProduct = parseJson(root.querySelector('[data-gcp-current-product]'));
    if (!config || !currentProduct) return;

    const dom = {
      brandButtons: root.querySelectorAll('[data-gcp-brand]'),
      modelSelect: root.querySelector('[data-gcp-model-select]'),
      caseGrid: root.querySelector('[data-gcp-case-grid]'),
      finishRow: root.querySelector('[data-gcp-finish-row]'),
      status: root.querySelector('[data-gcp-status-text]'),
      priceCurrent: root.querySelector('[data-gcp-price-current]'),
      priceCompare: root.querySelector('[data-gcp-price-compare]'),
      priceSave: root.querySelector('[data-gcp-price-save]'),
      summaryBrand: root.querySelector('[data-gcp-summary-brand]'),
      summaryModel: root.querySelector('[data-gcp-summary-model]'),
      summaryCase: root.querySelector('[data-gcp-summary-case]'),
      summaryFinish: root.querySelector('[data-gcp-summary-finish]'),
      caseDescription: root.querySelector('[data-gcp-case-description]'),
      casePill: root.querySelector('[data-gcp-case-pill]'),
      stepCard: root.querySelector('[data-gcp-step-card]'),
      subcopy: root.querySelector('[data-gcp-subcopy]'),
      shellCopy: root.querySelector('[data-gcp-shell-copy]'),
      personalizeSlot: root.querySelector('[data-gcp-personalize-slot]'),
      personalizeRetry: root.querySelector('[data-gcp-personalize-retry]'),
      nativeShell: root.querySelector('[data-gcp-native-shell-body]'),
      changeLink: root.querySelector('[data-gcp-change-link]'),
      entryHint: root.querySelector('[data-gcp-entry-hint]'),
      entryLink: root.querySelector('[data-gcp-entry-link]')
    };

    const pageParams = new URLSearchParams(window.location.search);
    if (
      config.templateSuffix !== 'gc-custom-personalize'
      && pageParams.get('view') !== 'gc-custom-personalize'
    ) {
      const personalizedTemplateUrl = new URL(window.location.href);
      personalizedTemplateUrl.searchParams.set('view', 'gc-custom-personalize');
      window.location.replace(personalizedTemplateUrl.toString());
      return;
    }
    const rawVariantById = new Map((currentProduct.variants || []).map(function (variant) {
      return [String(variant.id), variant];
    }));
    const state = {
      brand: normalizeBrand(pageParams.get('device') || ''),
      model: normalizeModel(pageParams.get('model') || ''),
      finish: normalizeFinishKey(pageParams.get('finish') || ''),
      currentCaseKey: config.currentCaseKey,
      caseKey: normalizeCaseKey(pageParams.get('case') || pageParams.get('case_key') || '') || config.currentCaseKey,
      variantId: String(pageParams.get('variant') || '')
    };
    const sourceContext = pageParams.get('from') || 'custom-product-page';
    const autoOpenRequested = sourceContext === 'design-your-own' && pageParams.get(AUTO_OPEN_PARAM) === '1';
    let lastSyncedUrl = '';
    const previewStorageKey = getPreviewStorageKey(config.currentHandle);
    let hasAutoOpenedPersonalizer = false;
    let autoOpenFallbackShown = false;
    let autoOpenFallbackTimerId = 0;
    let autoOpenRetryTimerId = 0;
    let personalizeLoadFallbackTimerId = 0;
    let personalizeUiSyncFrame = 0;
    let previewRefreshTimeoutIds = [];
    let pendingPreviewRemoval = false;
    let pendingPreviewFocus = false;
    let mediaGalleryRefreshSequence = 0;
    let unavailableRequestedModel = '';

    function publishSelectionEvent(name, reason) {
      window.GoCraftlyStorefrontEvents?.publish(name, {
        brand: state.brand, model: state.model, caseStyle: state.currentCaseKey,
        productHandle: config.currentHandle, variantId: state.variantId, reason: reason
      });
    }

    warmPersonalizeOrigin();

    let currentEntry = buildCatalogEntry(config.cases[state.currentCaseKey], currentProduct, state.currentCaseKey);
    if (!currentEntry) return;

    let cases = {
      [state.currentCaseKey]: currentEntry
    };
    const caseLoadPromises = new Map();
    let catalogHydrationPromise = null;
    let pendingCaseNavigationKey = '';
    const native = bindNativeVariantSync(dom.nativeShell, state);

    if (state.caseKey && state.caseKey !== state.currentCaseKey) {
      const didNavigate = await navigateToCaseWhenReady(state.caseKey, {
        brand: state.brand,
        model: state.model,
        finish: state.finish,
        preserveModel: true,
        preserveFinish: true,
        autoOpenPersonalize: autoOpenRequested
      });
      if (didNavigate) return;
      state.caseKey = state.currentCaseKey;
    }

    scheduleDeferredCatalogHydration();

    if (!state.brand) {
      state.brand = getBrandForModel(state.model) || getDefaultBrand(currentEntry) || 'iphone';
    }

    bindPersonalizationPreviewSync();
    bindCartEnhancements();
    bindPersonalizeModalViewport();
    bindUiEvents();
    syncEntryLinks();
    ensureValidSelection();
    render();
    scheduleAutoOpenFallback();
    scheduleAutoOpenRetry();
    schedulePersonalizeLoadFallback();

    dom.personalizeRetry?.addEventListener('click', function () {
      window.location.reload();
    });

    let nativeRefreshFrame = 0;
      const personalizeObserver = new MutationObserver(() => {
        if (nativeRefreshFrame) return;
        nativeRefreshFrame = window.requestAnimationFrame(function () {
          nativeRefreshFrame = 0;
          if (native) {
          native.invalidateCache();
          native.syncFromDom();
          ensureValidSelection();
          native.syncVariantId(state.variantId);
          }
          renderPriceAndSummary();
          syncPersonalizationProperties();
          schedulePersonalizeUiSync();
          if (pendingPreviewRemoval || getPersonalizeControlsState() === 'empty') {
            scheduleStoredPersonalizationPreviewRefresh(PREVIEW_CLEAR_REFRESH_DELAYS);
          }
        });
      });
    personalizeObserver.observe(dom.nativeShell || document.body, {
      childList: true,
      subtree: true
    });

    if (native) {
      native.onChange(() => {
        native.syncFromDom();
        ensureValidSelection();
        native.syncVariantId(state.variantId);
        render();
      });
      syncNativeFromState();
    }

    syncPersonalizeEntryUi();

    function bindPersonalizationPreviewSync() {
      applyStoredPersonalizationPreview();

      const mediaRoot = root.querySelector('.gcp-media-card') || root;
      let previewFrame = 0;
      const mediaObserver = new MutationObserver(function () {
        if (previewFrame) return;
        previewFrame = window.requestAnimationFrame(function () {
          previewFrame = 0;
          syncModelScopedGallery();
          applyStoredPersonalizationPreview();
        });
      });
      mediaObserver.observe(mediaRoot, { childList: true, subtree: true });

      window.addEventListener('message', function (event) {
        if (event.origin !== PERSONALIZE_ORIGIN) return;
        // Printify's earlier listener closes the modal before this listener runs.
        // The iframe window remains the source even when its modal is hidden.
        const trustedFrame = Array.from(document.querySelectorAll('iframe[id^="personalizeIframe-"]'))
          .find(function (frame) { return event.source === frame.contentWindow; });
        if (!trustedFrame) return;
        const message = event.data && typeof event.data === 'object' ? event.data : null;
        if (!message) return;

        if (message.type === 'PERSONALIZATION_APPLIED') {
          pendingPreviewRemoval = false;
          pendingPreviewFocus = true;
          const previewUrl = getPersonalizationPreviewUrl(message);
          if (!previewUrl || !window.GoCraftlyPurchaseState?.designId(getPersonalizationId(message))) {
            publishSelectionEvent('design_save_rejected', 'invalid_provider_payload');
            return;
          }

          primePersonalizationPreview(previewUrl);
          writePersonalizationPreview(previewStorageKey, {
            handle: config.currentHandle,
            variantId: state.variantId || config.currentVariantId || '',
            model: state.model || '',
            personalizationId: getPersonalizationId(message),
            saved: true,
            imageUrl: previewUrl,
            alt: currentProduct.title || 'Personalized case preview',
            updatedAt: Date.now()
          });
          applyPersonalizationPreview(root, previewUrl, currentProduct.title || 'Personalized case preview');
          syncPersonalizationProperties();
          publishSelectionEvent('design_saved');
          scheduleStoredPersonalizationPreviewRefresh(PREVIEW_APPLIED_REFRESH_DELAYS);
          schedulePreviewFocusOnMobile();
          clearAutoOpenParam();
          return;
        }

        if (isPersonalizationRemovalMessage(message)) {
          pendingPreviewRemoval = false;
          pendingPreviewFocus = false;
          clearStoredPersonalizationPreview({ forceGalleryRefresh: true });
          return;
        }

        if (message.type === 'CLOSE_PERSONALIZATION_MODAL') {
          window.setTimeout(function () {
            if (!hasCurrentSavedDesign()) publishSelectionEvent('personalizer_closed_without_save');
          }, 0);
          if (pendingPreviewRemoval) {
            pendingPreviewRemoval = false;
            pendingPreviewFocus = false;
            clearStoredPersonalizationPreview({ forceGalleryRefresh: true });
            return;
          }
          if (pendingPreviewFocus) {
            schedulePreviewFocusOnMobile();
          }
          scheduleStoredPersonalizationPreviewRefresh(PREVIEW_MODAL_CLOSE_REFRESH_DELAYS);
        }
      });

      document.addEventListener('click', function (event) {
        const removalTarget = event.target instanceof Element
          ? event.target.closest('button, a, [role="button"]')
          : null;

        if (!removalTarget) return;

        if (isPersonalizationModalRemoveIntentTarget(removalTarget)) {
          pendingPreviewRemoval = true;
          pendingPreviewFocus = false;
          window.setTimeout(function () {
            clearStoredPersonalizationPreview({ forceGalleryRefresh: true });
          }, 0);
          return;
        }

        if (!isPersonalizationPageRemoveIntentTarget(removalTarget)) return;

        pendingPreviewRemoval = true;
        pendingPreviewFocus = false;
        window.setTimeout(function () {
          clearStoredPersonalizationPreview({ forceGalleryRefresh: true });
        }, 0);
      }, true);

    }

    function applyStoredPersonalizationPreview() {
      const preview = readPersonalizationPreview(previewStorageKey);
      const scopedTargets = getCurrentModelGalleryTargets();
      if (preview && shouldClearStalePersonalizationPreview(preview)) {
        clearStoredPersonalizationPreview();
        return;
      }
      if (!preview || !preview.imageUrl || !isPreviewCompatibleWithState(preview)) {
        restoreOriginalPersonalizationPreview(root, scopedTargets.previewIndices);
        syncPersonalizationProperties();
        return;
      }
      applyPersonalizationPreview(
        root,
        preview.imageUrl,
        preview.alt || currentProduct.title || 'Personalized case preview',
        scopedTargets.previewIndices
      );
      syncPersonalizationProperties();
    }

    function clearStoredPersonalizationPreview(options) {
      pendingPreviewRemoval = false;
      pendingPreviewFocus = false;
      clearPersonalizationPreview(previewStorageKey);
      flushStoredPersonalizationPreview();
      if (options && options.forceGalleryRefresh) {
        scheduleOriginalMediaGalleryRefresh();
      }
      render();
      scheduleStoredPersonalizationPreviewRefresh(PREVIEW_CLEAR_REFRESH_DELAYS);
    }

    function scheduleOriginalMediaGalleryRefresh() {
      const refreshToken = ++mediaGalleryRefreshSequence;
      window.setTimeout(function () {
        refreshOriginalMediaGallery(refreshToken).catch(function () {
          flushStoredPersonalizationPreview();
        });
      }, 0);
    }

    async function refreshOriginalMediaGallery(refreshToken) {
      const currentMediaGallery = root.querySelector('media-gallery');
      if (!(currentMediaGallery instanceof HTMLElement)) return false;

      const response = await fetch(window.location.href, {
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) return false;

      const html = await response.text();
      if (refreshToken !== mediaGalleryRefreshSequence) return false;

      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const candidateRoots = Array.from(documentFragment.querySelectorAll('[data-gcp-root]'));
      const nextRoot = candidateRoots.find(function (candidate) {
        return candidate.id && candidate.id === root.id;
      }) || candidateRoots[0] || documentFragment;
      const nextMediaGallery = nextRoot.querySelector('media-gallery');

      if (!(nextMediaGallery instanceof HTMLElement)) return false;
      if (!currentMediaGallery.isConnected) return false;

      currentMediaGallery.replaceWith(nextMediaGallery);

      window.requestAnimationFrame(function () {
        if (!root.isConnected) return;
        syncModelScopedGallery();
        applyStoredPersonalizationPreview();
      });

      return true;
    }

    function ensureCaseLoaded(caseKey) {
      if (cases[caseKey]) return Promise.resolve(cases[caseKey]);
      if (caseLoadPromises.has(caseKey)) return caseLoadPromises.get(caseKey);

      const meta = config.cases[caseKey];
      if (!meta || !meta.handle) return Promise.resolve(null);

      const request = Promise.resolve()
        .then(function () {
          if (meta.handle === config.currentHandle) return currentProduct;
          return fetch('/products/' + meta.handle + '.js', { credentials: 'same-origin' })
            .then(function (response) {
              if (!response.ok) {
                throw new Error('Unable to load case product: ' + meta.handle);
              }
              return response.json();
            });
        })
        .then(function (product) {
          const entry = buildCatalogEntry(meta, product, caseKey);
          if (entry) cases[caseKey] = entry;
          return entry;
        })
        .catch(function () {
          return null;
        })
        .finally(function () {
          caseLoadPromises.delete(caseKey);
        });

      caseLoadPromises.set(caseKey, request);
      return request;
    }

    function hydrateCatalog() {
      if (catalogHydrationPromise) return catalogHydrationPromise;
      root.dataset.gcpCatalogHydrating = 'true';

      catalogHydrationPromise = Promise.allSettled(
        Object.keys(config.cases).map(function (caseKey) {
          return ensureCaseLoaded(caseKey);
        })
      ).then(function () {
        currentEntry = cases[state.currentCaseKey] || currentEntry;
        root.dataset.gcpCatalogHydrated = 'true';

        if (root.isConnected && !pendingCaseNavigationKey) {
          ensureValidSelection();
          render();
        }

        return cases;
      }).finally(function () {
        root.dataset.gcpCatalogHydrating = 'false';
      });

      return catalogHydrationPromise;
    }

    function navigateToCaseWhenReady(caseKey, options) {
      if (!caseKey || caseKey === state.currentCaseKey || pendingCaseNavigationKey) {
        return Promise.resolve(false);
      }

      let navigationStarted = false;
      pendingCaseNavigationKey = caseKey;
      root.dataset.gcpCaseNavigation = 'loading';
      root.setAttribute('aria-busy', 'true');

      return ensureCaseLoaded(caseKey)
        .then(function (entry) {
          if (!entry || !root.isConnected) return false;
          navigationStarted = navigateToCase(cases, caseKey, Object.assign({}, options, {
            sourceContext: sourceContext
          }));
          return navigationStarted;
        })
        .finally(function () {
          pendingCaseNavigationKey = '';
          if (!root.isConnected || navigationStarted) return;
          root.dataset.gcpCaseNavigation = 'ready';
          root.removeAttribute('aria-busy');
          render();
        });
    }

    function navigateToBestCaseForBrandWhenReady(brand, options) {
      if (!brand || pendingCaseNavigationKey) return Promise.resolve(false);

      const pendingKey = 'brand:' + brand;
      pendingCaseNavigationKey = pendingKey;
      root.dataset.gcpCaseNavigation = 'loading';
      root.setAttribute('aria-busy', 'true');

      return hydrateCatalog()
        .then(function () {
          if (!root.isConnected) return false;
          const targetCaseKey = getBestCaseForBrand(brand);
          pendingCaseNavigationKey = '';
          return navigateToCaseWhenReady(targetCaseKey, Object.assign({}, options, {
            brand: brand
          }));
        })
        .finally(function () {
          if (pendingCaseNavigationKey === pendingKey) {
            pendingCaseNavigationKey = '';
          }
          if (!root.isConnected || pendingCaseNavigationKey) return;
          root.dataset.gcpCaseNavigation = 'ready';
          root.removeAttribute('aria-busy');
          render();
        });
    }

    function scheduleDeferredCatalogHydration() {
      if (root.dataset.gcpCatalogHydrating === 'true' || catalogHydrationPromise) return;

      const startHydration = function () {
        hydrateCatalog();
      };

      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(startHydration, { timeout: 1200 });
        return;
      }

      window.setTimeout(startHydration, 400);
    }

    function bindUiEvents() {
      dom.brandButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (pendingCaseNavigationKey) return;
          const nextBrand = normalizeBrand(button.getAttribute('data-gcp-brand'));
          if (!nextBrand || nextBrand === state.brand) return;

          if (getModelsForCurrentCase(nextBrand).length) {
            unavailableRequestedModel = '';
            state.brand = nextBrand;
            state.model = getModelsForCurrentCase(nextBrand)[0] || '';
            state.finish = '';
            ensureValidSelection();
            syncNativeFromState();
            render();
            return;
          }

          navigateToBestCaseForBrandWhenReady(nextBrand, {
            model: '',
            finish: '',
            autoOpenPersonalize: autoOpenRequested
          });
        });
      });

      if (dom.modelSelect) {
        dom.modelSelect.addEventListener('change', () => {
          state.model = normalizeModel(dom.modelSelect.value);
          unavailableRequestedModel = '';
          state.finish = '';
          ensureValidSelection();
          syncNativeFromState();
          render();
        });
      }
    }

    function ensureValidSelection() {
      const modelsForCurrentBrand = getModelsForCurrentCase(state.brand);

      if (!modelsForCurrentBrand.length) {
        const redirectCaseKey = getBestCaseForBrand(state.brand) || state.currentCaseKey;
        if (redirectCaseKey !== state.currentCaseKey) {
          navigateToCaseWhenReady(redirectCaseKey, {
            brand: state.brand,
            model: '',
            finish: '',
            autoOpenPersonalize: autoOpenRequested
          });
          return;
        }
      }

      if (state.model && !modelsForCurrentBrand.includes(state.model)) {
        unavailableRequestedModel = state.model;
      }
      if (!state.model && !unavailableRequestedModel) {
        state.model = modelsForCurrentBrand[0] || '';
      }

      const finishOptions = getFinishOptions();
      const exactFinish = finishOptions.find((option) => option.key === state.finish);
      const preferredFinish = finishOptions.find((option) => option.available) || finishOptions[0];
      state.finish = exactFinish ? exactFinish.key : preferredFinish ? preferredFinish.key : '';

      const selectedVariant = getCurrentVariant(false);
      state.variantId = selectedVariant ? String(selectedVariant.id) : '';
    }

    function render() {
      renderBrandButtons();
      renderModelOptions();
      renderCaseCards();
      renderFinishButtons();
      renderPriceAndSummary();
      syncModelScopedGallery();
      syncPersonalizationProperties();
      syncPersonalizeEntryUi();
    }

    function clearScheduledPreviewRefreshes() {
      if (!previewRefreshTimeoutIds.length) return;
      previewRefreshTimeoutIds.forEach(function (timeoutId) {
        window.clearTimeout(timeoutId);
      });
      previewRefreshTimeoutIds = [];
    }

    function flushStoredPersonalizationPreview() {
      syncModelScopedGallery();
      applyStoredPersonalizationPreview();
    }

    function scheduleStoredPersonalizationPreviewRefresh(delays) {
      clearScheduledPreviewRefreshes();
      (Array.isArray(delays) ? delays : []).forEach(function (delay) {
        const normalizedDelay = Number(delay) || 0;
        const timeoutId = window.setTimeout(function () {
          flushStoredPersonalizationPreview();
        }, normalizedDelay);
        previewRefreshTimeoutIds.push(timeoutId);
      });
    }

    function schedulePreviewFocusOnMobile() {
      if (!pendingPreviewFocus) return;
      if (!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches)) return;

      const focusPreview = function () {
        if (!pendingPreviewFocus || getActivePersonalizeModal()) return false;
        const focusTarget = root.querySelector('.gcp-media-card, media-gallery, .product-information__media');
        if (!(focusTarget instanceof HTMLElement)) return false;
        return scrollElementFullyIntoMobileViewport(focusTarget);
      };

      window.setTimeout(function () {
        focusPreview();
      }, PREVIEW_FOCUS_DELAY_MS);

      window.setTimeout(function () {
        focusPreview();
        pendingPreviewFocus = false;
      }, PREVIEW_FOCUS_DELAY_MS + PREVIEW_FOCUS_FINE_TUNE_DELAY_MS);
    }

    function syncPersonalizeEntryUi() {
      syncOfficialPersonalizeButton();
      attemptAutoOpenPersonalize();
    }

    function schedulePersonalizeUiSync() {
      if (personalizeUiSyncFrame) return;
      personalizeUiSyncFrame = window.requestAnimationFrame(function () {
        personalizeUiSyncFrame = 0;
        syncPersonalizeEntryUi();
      });
    }

    function bindCartEnhancements() {
      const mutationRoot = root.closest('.shopify-section') || dom.nativeShell || root;
      let formSyncFrame = 0;
      const formObserver = new MutationObserver(function () {
        if (formSyncFrame) return;
        formSyncFrame = window.requestAnimationFrame(function () {
          formSyncFrame = 0;
          syncPersonalizationProperties();
        });
      });
      formObserver.observe(mutationRoot, { childList: true, subtree: true });

      root.addEventListener('submit', function (event) {
        if (!(event.target instanceof HTMLFormElement)) return;
        if (!isManagedProductForm(event.target)) return;
        syncPersonalizationProperties();
        if (!hasCurrentSavedDesign()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          showPurchaseRequirement();
        }
      }, true);
      // Includes sticky buttons associated to the form and accelerated checkout.
      document.addEventListener('click', function (event) {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        if (target.closest('[id^="personalize-button-"]') && root.contains(target)) {
          syncProviderOptions();
          if (!isPersonalizationPageRemoveIntentTarget(target)) publishSelectionEvent('personalizer_opened');
        }
        const control = target.closest('button[type="submit"], input[type="submit"], [name="add"], .accelerated-checkout-block');
        const form = control?.form || control?.closest('form');
        if (!control || (!root.contains(control) && !getProductForms().includes(form))) return;
        if (!hasCurrentSavedDesign()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          showPurchaseRequirement();
        }
      }, true);
    }

    function hasCurrentSavedDesign() {
      if (unavailableRequestedModel || !getCurrentVariant(false)?.available) return false;
      const forms = getProductForms();
      if (!forms.length) return false;
      const preview = readPersonalizationPreview(previewStorageKey);
      return forms.every(function (form) {
        const providerId = form.querySelector('[name="properties[Personalization ID]"]')?.value || '';
        return window.GoCraftlyPurchaseState?.hasSavedDesign(preview, {
          handle: config.currentHandle, variantId: state.variantId, model: state.model
        }, providerId) === true;
      });
    }

    function showPurchaseRequirement() {
      publishSelectionEvent('purchase_blocked', unavailableRequestedModel ? 'unsupported_model' : 'missing_saved_design');
      if (!dom.status) return;
      dom.status.hidden = false;
      dom.status.textContent = unavailableRequestedModel
        ? 'This case is not available for ' + unavailableRequestedModel + '. Choose a compatible phone model or case style.'
        : 'Upload your photo and save your design for this phone model before adding it to cart.';
      dom.status.scrollIntoView({ block: 'nearest' });
    }

    function syncProviderOptions() {
      const variant = rawVariantById.get(String(state.variantId));
      if (!variant) return;
      // Printify resolves the SKU only when ALL named options match. Horizon
      // omits selectors for fixed options (for example Surface), so supply them.
      (currentProduct.options || []).forEach(function (optionName, index) {
        const name = typeof optionName === 'string' ? optionName : optionName.name;
        const value = variant.options?.[index];
        if (!name || !value) return;
        const fieldName = 'options[' + name + ']';
        let field = Array.from(root.querySelectorAll('select')).find(function (select) {
          return select.name === fieldName;
        });
        if (!field) {
          field = document.createElement('select');
          field.name = fieldName;
          field.hidden = true;
          field.dataset.gcpProviderOption = 'true';
          root.appendChild(field);
        }
        if (field.dataset.gcpProviderOption === 'true' && field.options[0]?.value !== value) {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          field.replaceChildren(option);
        }
        field.value = value;
      });
    }

    function syncPersonalizationProperties() {
      syncProviderOptions();
      const preview = resolvePersonalizationPreview();
      const forms = getProductForms();
      if (!forms.length) return;

      forms.forEach(function (form) {
        upsertPropertyInput(form, PREVIEW_PROPERTY_KEY, preview ? preview.imageUrl || '' : '');
        upsertPropertyInput(form, PERSONALIZATION_ID_PROPERTY_KEY, preview ? preview.personalizationId || '' : '');
        upsertPropertyInput(form, PERSONALIZATION_MODEL_PROPERTY_KEY, state.model || '');
        upsertPropertyInput(form, PERSONALIZATION_CASE_PROPERTY_KEY, config.cases[state.currentCaseKey].name || '');
      });

      const addToCartComponents = Array.from(root.querySelectorAll('add-to-cart-component'));
      const previewImage = preview ? preview.imageUrl || '' : '';
      addToCartComponents.forEach(function (component) {
        if (!(component instanceof HTMLElement)) return;
        if (previewImage) {
          component.setAttribute('data-product-variant-media', previewImage);
        } else {
          component.removeAttribute('data-product-variant-media');
        }
      });
      const ready = hasCurrentSavedDesign();
      if (root.dataset.gcpDesignReady !== String(ready)) root.dataset.gcpDesignReady = String(ready);
      const section = root.closest('.shopify-section') || root;
      section.querySelectorAll('button[name="add"], button[type="submit"], input[type="submit"], sticky-add-to-cart button').forEach(function (button) {
        if (!root.contains(button) && !button.closest('sticky-add-to-cart')) return;
        if (button.disabled !== !ready) button.disabled = !ready;
        button.setAttribute('aria-disabled', String(!ready));
      });
      section.querySelectorAll('.accelerated-checkout-block').forEach(function (block) {
        if (block.hidden !== !ready) block.hidden = !ready;
      });
    }

    function getProductForms() {
      const scopedForms = [
        root,
        dom.nativeShell,
        root.closest('.shopify-section')
      ].flatMap(function (container) {
        return container
          ? Array.from(container.querySelectorAll('form[action*="/cart/add"], product-form-component form'))
          : [];
      });

      return scopedForms.filter(function (form, index, array) {
        return form instanceof HTMLFormElement && array.indexOf(form) === index;
      });
    }

    function resolvePersonalizationPreview() {
      const storedPreview = readPersonalizationPreview(previewStorageKey);
      if (storedPreview && isPreviewCompatibleWithState(storedPreview)) {
        return storedPreview;
      }

      const renderedPreviewUrl = getRenderedPersonalizationPreviewUrl();
      if (!renderedPreviewUrl) return null;

      const fallbackPreview = {
        handle: config.currentHandle,
        variantId: state.variantId || config.currentVariantId || '',
        model: state.model || '',
        personalizationId: storedPreview ? storedPreview.personalizationId || '' : '',
        imageUrl: renderedPreviewUrl,
        alt: currentProduct.title || 'Personalized case preview',
        updatedAt: Date.now()
      };

      writePersonalizationPreview(previewStorageKey, fallbackPreview);
      return fallbackPreview;
    }

    function getRenderedPersonalizationPreviewUrl() {
      const previewScope = root.closest('.shopify-section') || root;
      const imageCandidates = Array.from(previewScope.querySelectorAll('img[data-gcp-original-src]'));

      for (const image of imageCandidates) {
        if (!(image instanceof HTMLImageElement)) continue;
        const currentSrc = image.getAttribute('src') || image.currentSrc || image.src || '';
        const originalSrc = image.getAttribute('data-gcp-original-src') || '';
        if (!currentSrc || !originalSrc) continue;
        if (normalizeImageUrl(currentSrc) === normalizeImageUrl(originalSrc)) continue;
        return currentSrc;
      }

      const sourceCandidates = Array.from(previewScope.querySelectorAll('source[data-gcp-original-srcset]'));
      for (const source of sourceCandidates) {
        if (!(source instanceof HTMLSourceElement)) continue;
        const currentSrcset = source.getAttribute('srcset') || '';
        const originalSrcset = source.getAttribute('data-gcp-original-srcset') || '';
        if (!currentSrcset || !originalSrcset) continue;
        if (normalizeImageUrl(currentSrcset) === normalizeImageUrl(originalSrcset)) continue;
        return currentSrcset.split(',')[0].trim().split(' ')[0] || '';
      }

      return '';
    }

    function isManagedProductForm(form) {
      return getProductForms().includes(form);
    }

    function upsertPropertyInput(form, propertyKey, value) {
      if (!(form instanceof HTMLFormElement) || !propertyKey) return;
      const selector = `input[name="properties[${cssEscape(propertyKey)}]"]`;
      let input = form.querySelector(selector);
      if (!value) {
        if (input) input.remove();
        return;
      }

      if (!(input instanceof HTMLInputElement)) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${propertyKey}]`;
        input.setAttribute('data-gcp-property-key', propertyKey);
        form.appendChild(input);
      }

      input.value = value;
    }

    function syncModelScopedGallery() {
      const scopedTargets = getCurrentModelGalleryTargets();
      const hasScopedTargets = scopedTargets.allowedIndices.size > 0;
      const visibleSlideCount = hasScopedTargets ? scopedTargets.allowedIndices.size : 0;

      scopedTargets.slides.forEach(function (slide, index) {
        if (!(slide instanceof HTMLElement)) return;
        const slideHost = slide.closest('slideshow-slide') || slide;
        const shouldShow = !hasScopedTargets || scopedTargets.allowedIndices.has(index);
        if (slideHost instanceof HTMLElement) {
          slideHost.hidden = !shouldShow;
          slideHost.setAttribute('data-gcp-gallery-visible', String(shouldShow));
        }
      });

      scopedTargets.thumbnailGroups.forEach(function (group) {
        Array.from(group.children).forEach(function (thumbnail, index) {
          if (!(thumbnail instanceof HTMLElement)) return;
          const shouldShow = !hasScopedTargets || scopedTargets.allowedIndices.has(index);
          thumbnail.hidden = !shouldShow;
          thumbnail.setAttribute('aria-hidden', String(!shouldShow));
        });
      });

      const mediaCard = root.querySelector('.gcp-media-card');
      if (mediaCard instanceof HTMLElement) {
        const arrowButtons = Array.from(mediaCard.querySelectorAll("button[aria-label='Previous slide'], button[aria-label='Next slide']"));
        arrowButtons.forEach(function (button) {
          if (!(button instanceof HTMLElement)) return;
          const shouldShow = visibleSlideCount > 1;
          button.hidden = !shouldShow;
          button.setAttribute('aria-hidden', String(!shouldShow));
        });
      }

      if (!hasScopedTargets) return;

      const selectedThumbnail = scopedTargets.thumbnailGroups
        .flatMap(function (group) { return Array.from(group.children); })
        .find(function (thumbnail) {
          return thumbnail instanceof HTMLElement
            && !thumbnail.hidden
            && (thumbnail.getAttribute('aria-selected') === 'true' || thumbnail.getAttribute('aria-current') === 'true');
        });

      if (!selectedThumbnail) {
        const firstVisibleThumbnail = scopedTargets.thumbnailGroups
          .flatMap(function (group) { return Array.from(group.children); })
          .find(function (thumbnail) {
            return thumbnail instanceof HTMLElement && !thumbnail.hidden;
          });

        if (firstVisibleThumbnail instanceof HTMLElement) {
          window.setTimeout(function () {
            firstVisibleThumbnail.click();
          }, 0);
        }
      }
    }

    function getCurrentModelGalleryTargets() {
      const mediaGallery = root.querySelector('media-gallery');
      if (!mediaGallery) {
        return {
          allowedIndices: new Set(),
          previewIndices: new Set(),
          thumbnailGroups: [],
          slides: []
        };
      }

      const thumbnailGroups = Array.from(mediaGallery.querySelectorAll('.slideshow-controls__thumbnails'));
      const allSlides = Array.from(mediaGallery.querySelectorAll('.product-media-container'));
      const primarySlideCount = thumbnailGroups[0] instanceof HTMLElement
        ? thumbnailGroups[0].children.length
        : allSlides.length;
      const slides = allSlides.slice(0, primarySlideCount);
      const allVariantMediaIds = new Set();
      const allVariantImageUrls = new Set();
      const targetMediaIds = new Set();
      const targetImageUrls = new Set();

      currentEntry.variants.forEach(function (variant) {
        const rawVariant = rawVariantById.get(String(variant.id));
        const mediaId = rawVariant && rawVariant.featured_media && rawVariant.featured_media.id
          ? String(rawVariant.featured_media.id)
          : '';
        const imageUrl = rawVariant && rawVariant.featured_image && rawVariant.featured_image.src
          ? normalizeImageUrl(rawVariant.featured_image.src)
          : '';

        if (mediaId) allVariantMediaIds.add(mediaId);
        if (imageUrl) allVariantImageUrls.add(imageUrl);

        if (variant.model !== state.model) return;
        if (state.finish && variant.finishKey !== state.finish) return;
        if (mediaId) targetMediaIds.add(mediaId);
        if (imageUrl) targetImageUrls.add(imageUrl);
      });

      // Some products do not expose a finish option. Fall back to every featured
      // image for the selected model only when an exact finish image was not found.
      if (!targetMediaIds.size && !targetImageUrls.size) {
        currentEntry.variants.forEach(function (variant) {
          if (variant.model !== state.model) return;
          const rawVariant = rawVariantById.get(String(variant.id));
          const mediaId = rawVariant && rawVariant.featured_media && rawVariant.featured_media.id
            ? String(rawVariant.featured_media.id)
            : '';
          const imageUrl = rawVariant && rawVariant.featured_image && rawVariant.featured_image.src
            ? normalizeImageUrl(rawVariant.featured_image.src)
            : '';

          if (mediaId) targetMediaIds.add(mediaId);
          if (imageUrl) targetImageUrls.add(imageUrl);
        });
      }

      const allowedIndices = new Set();
      const previewIndices = new Set();
      const sharedCandidates = [];
      const seenImageUrls = new Set();
      slides.forEach(function (slide, index) {
        const mediaNode = slide.querySelector('.product-media');
        const slideImage = slide.querySelector('img');
        const mediaId = mediaNode ? String(mediaNode.getAttribute('data-media-id') || '') : '';
        const imageUrl = slideImage ? normalizeImageUrl(slideImage.getAttribute('src') || slideImage.currentSrc || slideImage.src || '') : '';

        const isSelectedVariantMedia =
          (mediaId && targetMediaIds.has(mediaId)) ||
          (imageUrl && targetImageUrls.has(imageUrl));
        const belongsToAnyVariant =
          (mediaId && allVariantMediaIds.has(mediaId)) ||
          (imageUrl && allVariantImageUrls.has(imageUrl));

        if (isSelectedVariantMedia) {
          allowedIndices.add(index);
          previewIndices.add(index);
          if (imageUrl) seenImageUrls.add(imageUrl);
          return;
        }

        if (!belongsToAnyVariant && (!imageUrl || !seenImageUrls.has(imageUrl))) {
          sharedCandidates.push({ index: index, imageUrl: imageUrl });
        }
      });

      sharedCandidates.slice(0, MAX_SHARED_GALLERY_MEDIA).forEach(function (candidate) {
        allowedIndices.add(candidate.index);
        if (candidate.imageUrl) seenImageUrls.add(candidate.imageUrl);
      });

      if (!allowedIndices.size && slides.length) {
        allowedIndices.add(0);
      }
      if (!previewIndices.size && allowedIndices.size) {
        previewIndices.add(Array.from(allowedIndices)[0]);
      }

      return {
        allowedIndices: allowedIndices,
        previewIndices: previewIndices,
        thumbnailGroups: thumbnailGroups,
        slides: slides
      };
    }

    function isPreviewCompatibleWithState(preview) {
      if (!preview || preview.handle !== config.currentHandle) return false;
      if (preview.model && state.model && normalizeModel(preview.model) !== normalizeModel(state.model)) {
        return false;
      }
      if (preview.variantId && state.variantId && String(preview.variantId) === String(state.variantId)) {
        return true;
      }
      return false;
    }

    function shouldClearStalePersonalizationPreview(preview) {
      if (!preview || !preview.imageUrl) return false;
      if (pendingPreviewRemoval) return true;
      if (getActivePersonalizeModal()) return false;
      if (!getPrimaryPersonalizeTarget()) return false;

      const controlsState = getPersonalizeControlsState();
      if (controlsState !== 'empty') return false;

      const updatedAt = Number(preview.updatedAt || 0);
      if (!updatedAt) return false;

      return (Date.now() - updatedAt) > PREVIEW_STATE_SETTLE_MS;
    }

    function getPersonalizeControlsState() {
      const texts = getPersonalizeTargets(root)
        .map(function (target) {
          return normalize(String(
            target.getAttribute('aria-label')
            || target.textContent
            || target.value
            || ''
          )).toLowerCase();
        })
        .filter(Boolean);

      if (!texts.length) return 'loading';

      if (texts.some(function (text) {
        return /remove|delete|clear|reset|edit|change saved|saved design|replace/.test(text);
      })) {
        return 'saved';
      }

      if (texts.some(function (text) {
        return /upload|add image|add photo|personalize|customize|open|start design|create design/.test(text);
      })) {
        return 'empty';
      }

      return 'unknown';
    }

    function renderBrandButtons() {
      dom.brandButtons.forEach((button) => {
        const brand = normalizeBrand(button.getAttribute('data-gcp-brand'));
        const brandExists = Object.values(cases).some((entry) => (entry.modelsByBrand[brand] || []).length);
        const catalogIsReady = root.dataset.gcpCatalogHydrated === 'true';
        const isActive = brand === state.brand;
        button.disabled = !brandExists && catalogIsReady;
        button.classList.toggle('is-loading', !brandExists && !catalogIsReady);
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
    }

    function renderModelOptions() {
      if (!dom.modelSelect) return;

      const models = getModelsForCurrentCase(state.brand);
      dom.modelSelect.innerHTML = '';

      if (unavailableRequestedModel) {
        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = unavailableRequestedModel + ' - not available for this case';
        placeholder.selected = true;
        placeholder.disabled = true;
        dom.modelSelect.appendChild(placeholder);
      }

      if (!models.length) {
        const placeholder = document.createElement('option');
        placeholder.textContent = 'No models available';
        dom.modelSelect.appendChild(placeholder);
        dom.modelSelect.disabled = true;
        return;
      }

      dom.modelSelect.disabled = false;
      models.forEach((model) => {
        const option = document.createElement('option');
        option.value = model;
        option.textContent = model;
        option.selected = model === state.model;
        dom.modelSelect.appendChild(option);
      });
    }

    function renderCaseCards() {
      if (!dom.caseGrid) return;
      dom.caseGrid.innerHTML = '';

      Object.keys(config.cases).forEach((caseKey) => {
        const meta = config.cases[caseKey];
        const entry = cases[caseKey];
        const availability = getCaseAvailability(caseKey, state.brand, state.model);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'gcp-case-card';
        const displayPrice = entry ? entry.price : 0;

        if (caseKey === state.currentCaseKey) {
          button.classList.add('is-current');
        }

        if (!entry) {
          button.classList.add('is-loading');
        } else if (!availability.supported) {
          button.classList.add('is-disabled');
          button.disabled = true;
        }

        const statusText = !entry
          ? 'Loading availability…'
          : !availability.supported
            ? 'Not available for this model'
          : availability.available
            ? 'Ready to customize'
            : 'Currently sold out';

        button.innerHTML = [
          '<span class="gcp-case-card__badge">' + escapeHtml(meta.badge) + '</span>',
          '<div class="gcp-case-card__title">' + escapeHtml(meta.name) + '</div>',
          '<div class="gcp-case-card__meta">' + escapeHtml(statusText) + '</div>',
          '<div class="gcp-case-card__summary">' + escapeHtml(meta.summary) + '</div>',
          '<div class="gcp-case-card__price">' + (displayPrice ? formatMoney(displayPrice) : 'Check availability') + '</div>'
        ].join('');

        button.addEventListener('click', () => {
          if (caseKey === state.currentCaseKey || pendingCaseNavigationKey) return;
          if (entry && !availability.supported) return;
          navigateToCaseWhenReady(caseKey, {
            brand: state.brand,
            model: state.model,
            finish: state.finish,
            preserveModel: true,
            preserveFinish: true
          });
        });

        dom.caseGrid.appendChild(button);
      });
    }

    function renderFinishButtons() {
      if (!dom.finishRow) return;
      dom.finishRow.innerHTML = '';

      const options = getFinishOptions();
      if (!options.length) {
        const chip = document.createElement('span');
        chip.className = 'gcp-finish-button is-active';
        chip.textContent = 'Standard';
        dom.finishRow.appendChild(chip);
        return;
      }

      options.forEach((option) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'gcp-finish-button';
        button.textContent = option.label;
        button.disabled = !option.available;
        if (option.key === state.finish) {
          button.classList.add('is-active');
        }

        button.addEventListener('click', () => {
          if (!option.available) return;
          state.finish = option.key;
          syncNativeFromState();
          render();
        });

        dom.finishRow.appendChild(button);
      });
    }

    function renderPriceAndSummary() {
      // Native options can hydrate after the initial entry links are rendered.
      // Keep the entry hint in sync with every resolved model change.
      if (dom.entryHint) dom.entryHint.hidden = Boolean(state.model);
      const currentVariant = getCurrentVariant(false);
      const displayPrice = currentVariant ? currentVariant.price : currentEntry.price;
      const compareAt = getCompareAtPrice(displayPrice, currentVariant ? currentVariant.compare_at_price : 0);
      const personalizeTargetReady = Boolean(getPrimaryPersonalizeTarget());
      const preview = readPersonalizationPreview(previewStorageKey);
      const hasSavedPreview = hasCurrentSavedDesign();
      const discount = compareAt > displayPrice ? Math.round(((compareAt - displayPrice) / compareAt) * 100) : 0;

      if (dom.priceCurrent) dom.priceCurrent.textContent = formatMoney(displayPrice);
      if (dom.priceCompare) {
        dom.priceCompare.hidden = !(compareAt > displayPrice);
        dom.priceCompare.textContent = compareAt > displayPrice ? formatMoney(compareAt) : '';
      }
      if (dom.priceSave) {
        dom.priceSave.hidden = !(discount > 0);
        dom.priceSave.textContent = discount > 0 ? 'Save ' + discount + '%' : '';
      }

      syncStickyVariantSummary(currentVariant);

      if (dom.summaryBrand) dom.summaryBrand.textContent = displayBrand(state.brand);
      if (dom.summaryModel) dom.summaryModel.textContent = state.model || '--';
      if (dom.summaryCase) dom.summaryCase.textContent = config.cases[state.currentCaseKey].name;
      if (dom.summaryFinish) dom.summaryFinish.textContent = getDisplayFinish();
      if (dom.casePill) dom.casePill.textContent = config.cases[state.currentCaseKey].name;
      if (dom.caseDescription) dom.caseDescription.textContent = getCaseDescription();
      if (dom.changeLink) {
        dom.changeLink.href = buildDesignYourOwnUrl({
          brand: state.brand,
          model: state.model,
          finish: state.finish,
          variantId: currentVariant ? currentVariant.id : '',
          caseKey: state.currentCaseKey,
          sourceContext: sourceContext,
          edit: true
        });
      }
      if (dom.entryLink) {
        dom.entryLink.href = buildDesignYourOwnUrl({
          brand: state.brand,
          model: state.model,
          finish: state.finish,
          variantId: currentVariant ? currentVariant.id : '',
          caseKey: state.currentCaseKey,
          sourceContext: sourceContext
        });
      }

      syncLandingCopy(currentVariant, personalizeTargetReady, hasSavedPreview);
      updateHelperStatus(currentVariant, personalizeTargetReady, hasSavedPreview);
      syncNativePersonalizeState(hasSavedPreview);

      syncPageUrl(currentVariant);
    }

    function buildSelectionSentence() {
      const parts = [];
      if (state.model) parts.push(state.model);
      parts.push(config.cases[state.currentCaseKey].name);
      parts.push(getDisplayFinish());
      return parts.join(' · ');
    }

    function updateHelperStatus(currentVariant, personalizeTargetReady, hasSavedPreview) {
      if (!dom.status) return;

      let message = '';
      if (unavailableRequestedModel) {
        message = 'This case is not available for ' + unavailableRequestedModel + '. Choose a compatible phone model or case style.';
      } else if (!state.model) {
        message = 'Choose a phone model to continue.';
      } else if (!currentVariant) {
        message = 'This combination is not available yet. Try another finish or case style.';
      } else if (!currentVariant.available) {
        message = 'This option is sold out right now. Try another finish or case style.';
      } else if (autoOpenRequested && autoOpenFallbackShown) {
        message = 'The photo uploader is taking longer than usual. Please tap the button below to continue.';
      } else if (autoOpenRequested && !hasSavedPreview && !hasAutoOpenedPersonalizer) {
        message = 'Opening the photo uploader...';
      } else if (!personalizeTargetReady) {
        message = 'Loading the official upload button...';
      } else if (!hasSavedPreview) {
        message = 'Upload your photo and save your design before adding it to cart.';
      } else if (hasSavedPreview) {
        message = 'Your design preview is ready. You can add it to cart below.';
      }

      dom.status.hidden = !message;
      dom.status.textContent = message;
    }

    function syncLandingCopy(currentVariant, personalizeTargetReady, hasSavedPreview) {
      if (dom.subcopy) {
        if (autoOpenRequested && autoOpenFallbackShown) {
          dom.subcopy.textContent = 'Your phone model and case style are ready. The photo uploader is taking longer than usual, so you can use the button below to continue.';
        } else if (autoOpenRequested && !hasSavedPreview) {
          dom.subcopy.textContent = 'Your phone model and case style are ready. We’re opening the photo uploader so you can preview your custom case before checkout.';
        } else {
          dom.subcopy.textContent = 'Your phone model and case style are ready. Upload your favorite photo and preview your custom case before checkout.';
        }
      }

      if (!dom.shellCopy) return;

      if (!state.model) {
        dom.shellCopy.textContent = 'Start by choosing your phone model so we can load the official uploader.';
        return;
      }

      if (hasSavedPreview) {
        dom.shellCopy.textContent = 'Your design is saved. You can add it to cart below or reopen the official uploader if you want to make changes.';
        return;
      }

      if (autoOpenRequested && autoOpenFallbackShown) {
        dom.shellCopy.textContent = 'The photo uploader is taking longer than usual. Please tap the official button below to continue.';
        return;
      }

      if (autoOpenRequested) {
        dom.shellCopy.textContent = personalizeTargetReady && currentVariant
          ? 'We’re opening the official photo uploader for you now.'
          : 'We’re getting the official photo uploader ready for your selected variant.';
        return;
      }

      dom.shellCopy.textContent = 'Review your selection, then use the official upload button below to open Printify personalization.';
    }

    function syncNativePersonalizeState(hasSavedPreview) {
      if (!dom.nativeShell) return;
      const personalizeTarget = getPrimaryPersonalizeTarget();
      const targetText = personalizeTarget ? normalize(personalizeTarget.textContent || '').toLowerCase() : '';
      const showSecondaryState = Boolean(hasSavedPreview && /remove|edit|change/.test(targetText));
      dom.nativeShell.classList.toggle('gcp-native-shell__body--has-preview', hasSavedPreview);
      dom.nativeShell.classList.toggle('gcp-native-shell__body--personalize-ready', Boolean(personalizeTarget));
      if (dom.personalizeSlot) {
        dom.personalizeSlot.classList.toggle('is-secondary', showSecondaryState);
      }
    }

    function syncEntryLinks() {
      const changeUrl = buildDesignYourOwnUrl({
        brand: state.brand,
        model: state.model,
        finish: state.finish,
        variantId: state.variantId,
        caseKey: state.currentCaseKey,
        sourceContext: sourceContext,
        edit: true
      });
      const entryUrl = buildDesignYourOwnUrl({
        brand: state.brand,
        model: state.model,
        finish: state.finish,
        variantId: state.variantId,
        caseKey: state.currentCaseKey,
        sourceContext: sourceContext
      });
      if (dom.changeLink) dom.changeLink.href = changeUrl;
      if (dom.entryLink) dom.entryLink.href = entryUrl;
      if (dom.entryHint) {
        dom.entryHint.hidden = Boolean(state.model);
      }
    }

    function syncStickyVariantSummary(currentVariant) {
      if (!currentVariant) return;

      const sectionRoot = root.closest('.shopify-section') || document;
      const stickyAddToCart = sectionRoot.querySelector('sticky-add-to-cart');
      if (!stickyAddToCart) return;

      const rawVariant = rawVariantById.get(String(currentVariant.id));
      const stickyVariantTitle = stickyAddToCart.querySelector('[data-testid="sticky-variant-title"]');
      if (stickyVariantTitle) {
        stickyVariantTitle.textContent = rawVariant && rawVariant.title
          ? rawVariant.title
          : state.model;
      }

      stickyAddToCart.dataset.currentVariantId = String(currentVariant.id);
      stickyAddToCart.dataset.variantAvailable = String(Boolean(currentVariant.available));
    }

    function syncOfficialPersonalizeButton() {
      if (!dom.personalizeSlot) return false;

      const target = getPrimaryPersonalizeTarget();
      if (!target) {
        if (dom.personalizeSlot.dataset.state !== 'delayed') {
          dom.personalizeSlot.dataset.state = 'loading';
          dom.personalizeSlot.dataset.statusLabel = autoOpenRequested && !autoOpenFallbackShown
            ? 'Opening the photo uploader...'
            : 'Loading upload tools...';
        }
        return false;
      }

      if (personalizeLoadFallbackTimerId) {
        window.clearTimeout(personalizeLoadFallbackTimerId);
        personalizeLoadFallbackTimerId = 0;
      }
      if (dom.personalizeRetry) dom.personalizeRetry.hidden = true;
      const container = target.closest('.personalize-container') || target;
      if (container.parentElement !== dom.personalizeSlot) {
        dom.personalizeSlot.appendChild(container);
      }

      dom.personalizeSlot.dataset.state = 'ready';
      dom.personalizeSlot.dataset.statusLabel = '';

      if (sourceContext === 'design-your-own' && root.dataset.gcpStepReady !== 'true') {
        root.dataset.gcpStepReady = 'true';
        if (dom.stepCard) {
          dom.stepCard.classList.add('is-ready');
        }
        if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches && dom.stepCard) {
          window.setTimeout(function () {
            dom.stepCard.scrollIntoView({
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
              block: 'start'
            });
          }, 120);
        }
      }

      return true;
    }

    function schedulePersonalizeLoadFallback() {
      if (!dom.personalizeSlot || personalizeLoadFallbackTimerId || getPrimaryPersonalizeTarget()) return;
      personalizeLoadFallbackTimerId = window.setTimeout(function () {
        personalizeLoadFallbackTimerId = 0;
        if (getPrimaryPersonalizeTarget()) {
          syncOfficialPersonalizeButton();
          return;
        }
        dom.personalizeSlot.dataset.state = 'delayed';
        dom.personalizeSlot.dataset.statusLabel = 'Upload tools did not finish loading. Refresh to try again.';
        if (dom.personalizeRetry) dom.personalizeRetry.hidden = false;
      }, PERSONALIZE_LOAD_TIMEOUT_MS);
    }

    function getCaseDescription() {
      switch (state.currentCaseKey) {
        case 'tough_case':
          return 'Extra everyday protection with a clean, durable feel.';
        case 'tough_magsafe_case':
          return 'Protective and MagSafe-ready for easy everyday charging.';
        case 'clear_magsafe_case':
          return 'A lighter, clearer look with easy MagSafe compatibility.';
        case 'biodegradable_case':
          return 'A lighter biodegradable case with easy everyday protection.';
        case 'frosted_clear_case':
          return 'A frosted matte clear case for iPhone and Samsung.';
        case 'tough_magnetic_case':
          return 'A protective Samsung case with a built-in magnetic ring.';
        default:
          return '';
      }
    }

    function syncNativeFromState() {
      if (!native || !native.modelSelect) return;

      const modelChanged = setNativeSelectValue(native.modelSelect, state.model, normalizeModel);
      const finishLabel = getFinishLabel(state.finish);
      const finishChanged = native.finishSelect && state.finish
        ? setNativeSelectValue(native.finishSelect, finishLabel, function (value) {
            return normalizeFinishKey(value);
          })
        : false;

      // Keep cart submission authoritative while Horizon refreshes variant UI asynchronously.
      native.syncVariantId(state.variantId);

      if (!modelChanged && !finishChanged) return;

      if (modelChanged) dispatchNativeChange(native.modelSelect);
      if (finishChanged && native.finishSelect) dispatchNativeChange(native.finishSelect);

      window.setTimeout(() => {
        native.syncFromDom();
        ensureValidSelection();
        native.syncVariantId(state.variantId);
        renderPriceAndSummary();
        syncPersonalizationProperties();
        schedulePersonalizeUiSync();
      }, 140);
    }

    function getPrimaryPersonalizeTarget() {
      const targets = getPersonalizeTargets(root);
      return targets.find(function (target) {
        return target
          && !target.disabled
          && target.getAttribute('aria-disabled') !== 'true';
      }) || null;
    }

    function isLandingReadyForPersonalize() {
      return Boolean(
        state.model
        && state.variantId
        && getPrimaryPersonalizeTarget()
      );
    }

    function isNativeVariantReady() {
      if (!state.variantId) return false;
      if (!native || typeof native.getVariantId !== 'function') return true;

      const nativeVariantId = native.getVariantId();
      if (!nativeVariantId) return false;
      return String(nativeVariantId) === String(state.variantId);
    }

    function attemptAutoOpenPersonalize() {
      if (!autoOpenRequested || hasAutoOpenedPersonalizer || autoOpenFallbackShown) return;
      if (!isLandingReadyForPersonalize() || !isNativeVariantReady()) return;

      const target = getPrimaryPersonalizeTarget();
      if (!target) return;
      const invocation = getPersonalizeInvocation(target);
      if (invocation.matched && !invocation.ready) return;

      hasAutoOpenedPersonalizer = true;
      if (autoOpenFallbackTimerId) {
        window.clearTimeout(autoOpenFallbackTimerId);
        autoOpenFallbackTimerId = 0;
      }

      window.requestAnimationFrame(function () {
        triggerPersonalizeTarget(target);
        window.setTimeout(function () {
          if (getActivePersonalizeModal()) {
            clearAutoOpenRetry();
            clearAutoOpenParam();
            return;
          }

          if (!readPersonalizationPreview(previewStorageKey)) {
            hasAutoOpenedPersonalizer = false;
          }
        }, 700);
      });
    }

    function triggerPersonalizeTarget(target) {
      if (!target) return;
      const invocation = getPersonalizeInvocation(target);
      if (invocation.ready) {
        invocation.invoker.openPersonalizeModal(invocation.modalId);
        return;
      }

      target.click();
      window.setTimeout(function () {
        if (getActivePersonalizeModal()) return;
        target.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      }, 140);
    }

    function getPersonalizeInvocation(target) {
      const onclick = target && typeof target.getAttribute === 'function'
        ? target.getAttribute('onclick')
        : '';
      const match = onclick && onclick.match(/window\[['"]([^'"]+)['"]\]\.openPersonalizeModal\((['"])([^'"]+)\2\)/);
      if (!match) {
        return { matched: false, ready: false, invoker: null, modalId: '' };
      }

      const invoker = window[match[1]];
      return {
        matched: true,
        ready: Boolean(invoker && typeof invoker.openPersonalizeModal === 'function'),
        invoker: invoker || null,
        modalId: match[3]
      };
    }

    function getActivePersonalizeModal() {
      const modal = document.querySelector('.personalize-modal');
      if (!modal) return null;

      const style = window.getComputedStyle(modal);
      if (style.display === 'none' || style.visibility === 'hidden') return null;

      const rect = modal.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0) return null;

      return modal;
    }

    function bindPersonalizeModalViewport() {
      let modalViewportFrame = 0;

      const syncModalViewport = function () {
        modalViewportFrame = 0;
        const modal = getActivePersonalizeModal();
        const isOpen = Boolean(modal);
        document.documentElement.classList.toggle('gcp-personalize-modal-open', isOpen);

        if (!isOpen) return;

        const viewport = window.visualViewport;
        const height = Math.max(360, Math.floor(viewport ? viewport.height : window.innerHeight));
        const heightValue = height + 'px';
        document.documentElement.style.setProperty('--gcp-visual-viewport-height', heightValue);
        modal.style.setProperty('--gcp-visual-viewport-height', heightValue);

        const iframe = modal.querySelector('.personalize-modal__iframe, iframe[src*="personalize.at"]');
        if (iframe) {
          const modalRect = modal.getBoundingClientRect();
          const iframeRect = iframe.getBoundingClientRect();
          const iframeOffsetTop = Math.max(0, Math.round(iframeRect.top - modalRect.top));
          const iframeHeight = Math.max(320, height - iframeOffsetTop);
          const shouldCompactFrame = window.matchMedia
            && window.matchMedia('(max-width: 749px)').matches
            && iframeHeight < 900;
          const frameScale = shouldCompactFrame ? 0.82 : 1;
          const scaledIframeHeight = Math.ceil(iframeHeight / frameScale);
          const scaledIframeWidth = Math.ceil(100 / frameScale * 1000) / 1000;
          iframe.style.setProperty('--gcp-visual-viewport-height', heightValue);
          iframe.style.setProperty('--gcp-personalize-iframe-height', iframeHeight + 'px');
          iframe.style.setProperty('--gcp-personalize-frame-scale', String(frameScale));
          iframe.style.setProperty('--gcp-personalize-scaled-iframe-height', scaledIframeHeight + 'px');
          iframe.style.setProperty('--gcp-personalize-scaled-iframe-width', scaledIframeWidth + '%');
          modal.style.setProperty('--gcp-personalize-iframe-height', iframeHeight + 'px');
          modal.style.setProperty('--gcp-personalize-frame-scale', String(frameScale));
          modal.style.setProperty('--gcp-personalize-scaled-iframe-height', scaledIframeHeight + 'px');
          modal.style.setProperty('--gcp-personalize-scaled-iframe-width', scaledIframeWidth + '%');
        }
      };

      const scheduleModalViewportSync = function () {
        if (modalViewportFrame) return;
        modalViewportFrame = window.requestAnimationFrame(syncModalViewport);
      };

      const modalViewportObserver = new MutationObserver(scheduleModalViewportSync);
      modalViewportObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
      });

      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', scheduleModalViewportSync, { passive: true });
        window.visualViewport.addEventListener('scroll', scheduleModalViewportSync, { passive: true });
      }
      window.addEventListener('resize', scheduleModalViewportSync, { passive: true });
      window.addEventListener('orientationchange', scheduleModalViewportSync, { passive: true });
      scheduleModalViewportSync();
    }

    function scheduleAutoOpenFallback() {
      if (!autoOpenRequested || autoOpenFallbackTimerId) return;
      autoOpenFallbackTimerId = window.setTimeout(function () {
        autoOpenFallbackTimerId = 0;
        if (!hasAutoOpenedPersonalizer && !getActivePersonalizeModal() && !readPersonalizationPreview(previewStorageKey)) {
          showAutoOpenFallback();
        }
      }, AUTO_OPEN_TIMEOUT_MS);
    }

    function scheduleAutoOpenRetry() {
      if (!autoOpenRequested || autoOpenRetryTimerId) return;
      autoOpenRetryTimerId = window.setInterval(function () {
        if (autoOpenFallbackShown || getActivePersonalizeModal()) {
          clearAutoOpenRetry();
          return;
        }
        attemptAutoOpenPersonalize();
      }, 250);
    }

    function clearAutoOpenRetry() {
      if (!autoOpenRetryTimerId) return;
      window.clearInterval(autoOpenRetryTimerId);
      autoOpenRetryTimerId = 0;
    }

    function showAutoOpenFallback() {
      if (autoOpenFallbackShown) return;
      autoOpenFallbackShown = true;
      clearAutoOpenRetry();
      if (dom.stepCard) {
        dom.stepCard.classList.add('is-ready');
      }
      renderPriceAndSummary();
      syncOfficialPersonalizeButton();
    }

    function clearAutoOpenParam() {
      if (!window.history || !window.history.replaceState) return;
      const url = new URL(window.location.href);
      if (!url.searchParams.has(AUTO_OPEN_PARAM)) return;
      url.searchParams.delete(AUTO_OPEN_PARAM);
      lastSyncedUrl = url.toString();
      window.history.replaceState({}, '', lastSyncedUrl);
    }

    function syncPageUrl(currentVariant) {
      if (!window.history || !window.history.replaceState) return;

      const url = new URL(window.location.href);
      if (currentVariant && currentVariant.id) {
        url.searchParams.set('variant', currentVariant.id);
      } else {
        url.searchParams.delete('variant');
      }
      if (state.brand) url.searchParams.set('device', state.brand);
      if (state.model) url.searchParams.set('model', state.model);
      if (state.finish && state.finish !== 'default') {
        url.searchParams.set('finish', state.finish);
      } else {
        url.searchParams.delete('finish');
      }
      if (state.currentCaseKey) {
        url.searchParams.set('case', state.currentCaseKey);
        url.searchParams.set('case_key', state.currentCaseKey);
      }
      url.searchParams.set('from', sourceContext);

      const nextUrl = url.toString();
      if (nextUrl === lastSyncedUrl || nextUrl === window.location.href) {
        lastSyncedUrl = nextUrl;
        return;
      }

      lastSyncedUrl = nextUrl;
      window.history.replaceState({}, '', nextUrl);
    }

    function getModelsForCurrentCase(brand) {
      return sortModels((currentEntry.modelsByBrand[brand] || []).slice(), brand);
    }

    function getFinishOptions() {
      const finishes = new Map();

      currentEntry.variants.forEach((variant) => {
        if (variant.brand !== state.brand || variant.model !== state.model) return;

        const key = variant.finishKey || 'default';
        if (!finishes.has(key)) {
          finishes.set(key, {
            key: key,
            label: variant.finishLabel || 'Standard',
            available: Boolean(variant.available)
          });
          return;
        }

        if (variant.available) {
          finishes.get(key).available = true;
        }
      });

      return Array.from(finishes.values());
    }

    function getCurrentVariant(availableOnly) {
      const exactMatch = currentEntry.variants.find((variant) => {
        if (variant.brand !== state.brand || variant.model !== state.model) return false;
        if ((variant.finishKey || 'default') !== (state.finish || 'default')) return false;
        if (availableOnly) return Boolean(variant.available);
        return true;
      });

      if (exactMatch) return exactMatch;

      if (availableOnly) {
        return currentEntry.variants.find((variant) => {
          return variant.brand === state.brand && variant.model === state.model && Boolean(variant.available);
        }) || null;
      }

      return null;
    }

    function getCaseAvailability(caseKey, brand, model) {
      const entry = cases[caseKey];
      if (!entry) return { supported: false, available: false };

      const matches = entry.variants.filter((variant) => {
        if (variant.brand !== brand) return false;
        if (!model) return true;
        return variant.model === model;
      });

      return {
        supported: matches.length > 0,
        available: matches.some((variant) => Boolean(variant.available))
      };
    }

    function getBestCaseForBrand(brand) {
      const preferredKeys = ['tough_case', 'clear_magsafe_case', 'tough_magsafe_case', 'biodegradable_case', 'frosted_clear_case', 'tough_magnetic_case'];
      const availableCase = preferredKeys.find((caseKey) => {
        const entry = cases[caseKey];
        return entry
          && (entry.modelsByBrand[brand] || []).length > 0
          && entry.variants.some((variant) => variant.brand === brand && variant.available);
      });

      if (availableCase) return availableCase;

      return preferredKeys.find((caseKey) => {
        const entry = cases[caseKey];
        return entry && (entry.modelsByBrand[brand] || []).length > 0;
      }) || state.currentCaseKey;
    }

    function getDefaultBrand(entry) {
      if ((entry.modelsByBrand.iphone || []).length) return 'iphone';
      if ((entry.modelsByBrand.samsung || []).length) return 'samsung';
      return '';
    }

    function getDisplayFinish() {
      if (!state.finish) return 'Standard';
      return getFinishLabel(state.finish);
    }

    function getFinishLabel(finishKey) {
      const option = getFinishOptions().find((item) => item.key === finishKey);
      if (option) return option.label;
      return finishKey === 'default' ? 'Standard' : finishKey;
    }
  }

  function buildCatalogEntry(meta, product, caseKey) {
    if (!meta || !product) return null;

    const entry = {
      caseKey: caseKey,
      handle: meta.handle,
      name: meta.name,
      badge: meta.badge,
      summary: meta.summary,
      price: Number(product.price_min || product.price || 0),
      modelsByBrand: { iphone: [], samsung: [] },
      variants: []
    };

    const optionNames = Array.isArray(product.options)
      ? product.options.map(function (option) {
          return normalize(String(option && option.name ? option.name : option));
        })
      : [];

    (product.variants || []).forEach(function (variant) {
      const parsed = parseVariant(variant, optionNames);
      if (!parsed) return;

      entry.variants.push(parsed);
      if (!entry.modelsByBrand[parsed.brand].includes(parsed.model)) {
        entry.modelsByBrand[parsed.brand].push(parsed.model);
      }
    });

    return entry;
  }

  function bindNativeVariantSync(container, state) {
    if (!container) return null;

    let cachedSelects = null;
    let cachedModelSelect = null;
    let cachedFinishSelect = null;
    let cachedIdInput = null;

    function isConnectedElement(element) {
      return element instanceof Element && element.isConnected && container.contains(element);
    }

    function invalidateCache() {
      cachedSelects = null;
      cachedModelSelect = null;
      cachedFinishSelect = null;
      cachedIdInput = null;
    }

    function getSelects() {
      if (cachedSelects && cachedSelects.every(isConnectedElement)) return cachedSelects;

      cachedSelects = Array.from(container.querySelectorAll('select')).filter(function (select) {
        return select.options.length > 0;
      });
      cachedModelSelect = null;
      cachedFinishSelect = null;
      return cachedSelects;
    }

    function getModelSelect() {
      if (isConnectedElement(cachedModelSelect)) return cachedModelSelect;

      cachedModelSelect = getSelects().find(function (select) {
        const optionText = Array.from(select.options).map(function (option) {
          return normalize(option.textContent || option.value).toLowerCase();
        });
        return optionText.some(function (value) {
          return value.includes('iphone') || value.includes('samsung') || value.includes('galaxy');
        });
      }) || null;
      return cachedModelSelect;
    }

    function getFinishSelect(modelSelect) {
      if (isConnectedElement(cachedFinishSelect) && cachedFinishSelect !== modelSelect) return cachedFinishSelect;

      cachedFinishSelect = getSelects().find(function (select) {
        if (select === modelSelect) return false;
        const optionText = Array.from(select.options).map(function (option) {
          return normalize(option.textContent || option.value).toLowerCase();
        });
        return optionText.some(function (value) {
          return value.includes('gloss') || value.includes('matt') || value.includes('matte') || value.includes('standard');
        });
      }) || null;
      return cachedFinishSelect;
    }

    function getIdInput() {
      if (isConnectedElement(cachedIdInput)) return cachedIdInput;
      cachedIdInput = container.querySelector('[name="id"]');
      return cachedIdInput;
    }

    function onChange(callback) {
      let changeFrame = 0;
      container.addEventListener('change', function (event) {
        const modelSelect = getModelSelect();
        const finishSelect = getFinishSelect(modelSelect);
        const idInput = getIdInput();
        if (event.target !== modelSelect && event.target !== finishSelect && event.target !== idInput) return;
        if (changeFrame) return;
        changeFrame = window.requestAnimationFrame(function () {
          changeFrame = 0;
          callback();
        });
      });
    }

    function syncFromDom() {
      const modelSelect = getModelSelect();
      const finishSelect = getFinishSelect(modelSelect);
      const idInput = getIdInput();
      if (modelSelect) {
        state.model = normalizeModel(getSelectedText(modelSelect));
        state.brand = getBrandForModel(state.model) || state.brand;
      }

      if (finishSelect) {
        state.finish = normalizeFinishKey(getSelectedText(finishSelect)) || state.finish;
      } else {
        state.finish = 'default';
      }

      if (idInput && idInput.value) {
        state.variantId = String(idInput.value);
      }
    }

    function syncVariantId(variantId) {
      if (!variantId) return;
      const normalizedVariantId = String(variantId);
      const idInput = getIdInput();
      if (idInput && idInput.value !== normalizedVariantId) {
        idInput.value = normalizedVariantId;
        idInput.setAttribute('value', normalizedVariantId);
      }

      const modelSelect = getModelSelect();
      const finishSelect = getFinishSelect(modelSelect);
      [modelSelect, finishSelect].forEach(function (select) {
        const selectedOption = select && select.selectedOptions ? select.selectedOptions[0] : null;
        if (!selectedOption || selectedOption.dataset.variantId === normalizedVariantId) return;
        selectedOption.dataset.variantId = normalizedVariantId;
      });
    }

    return {
      get modelSelect() {
        return getModelSelect();
      },
      get finishSelect() {
        return getFinishSelect(getModelSelect());
      },
      getVariantId: function () {
        const idInput = getIdInput();
        return idInput && idInput.value ? String(idInput.value) : '';
      },
      invalidateCache: invalidateCache,
      onChange: onChange,
      syncFromDom: syncFromDom,
      syncVariantId: syncVariantId
    };
  }

  function parseVariant(variant, optionNames) {
    const values = [variant.option1, variant.option2, variant.option3]
      .map(function (value) {
        return normalize(value);
      })
      .filter(Boolean);

    let model = '';
    let finish = '';

    values.forEach(function (value, index) {
      const optionName = normalize((optionNames || [])[index]).toLowerCase();
      if (!model && (optionName.includes('size') || optionName.includes('model') || optionName.includes('device') || optionName.includes('phone'))) {
        model = value;
      }
      if (!finish && (optionName.includes('surface') || optionName.includes('finish') || optionName.includes('material') || optionName.includes('style'))) {
        finish = value;
      }
    });

    if (!model) {
      model = values.find(function (value) {
        return /iphone|galaxy|samsung/i.test(value);
      }) || '';
    }

    if (!finish) {
      finish = values.find(function (value) {
        return /gloss|matt|matte|standard/i.test(value);
      }) || 'Standard';
    }

    model = normalizeModel(model);
    if (!model) return null;

    const finishKey = normalizeFinishKey(finish) || 'default';

    return {
      id: variant.id,
      price: Number(variant.price || 0),
      compare_at_price: Number(variant.compare_at_price || 0),
      available: Boolean(variant.available),
      brand: getBrandForModel(model),
      model: model,
      finishKey: finishKey,
      finishLabel: finishKey === 'default' ? 'Standard' : normalize(finish)
    };
  }

  function navigateToCase(cases, caseKey, options) {
    const target = cases[caseKey];
    if (!target) return false;

    const requestedBrand = options && options.brand ? normalizeBrand(options.brand) : '';
    const fallbackBrand = (target.modelsByBrand.iphone || []).length
      ? 'iphone'
      : (target.modelsByBrand.samsung || []).length
        ? 'samsung'
        : '';
    const targetBrand = requestedBrand && (target.modelsByBrand[requestedBrand] || []).length
      ? requestedBrand
      : fallbackBrand || 'iphone';
    const targetModels = sortModels((target.modelsByBrand[targetBrand] || []).slice(), targetBrand);
    const requestedModel = normalizeModel(options && options.model ? options.model : '');
    const targetModel = requestedModel && targetModels.includes(requestedModel)
      ? requestedModel
      : targetModels[0] || '';
    if (!targetModel) return false;

    const matchingVariants = target.variants.filter(function (variant) {
      return variant.brand === targetBrand && variant.model === targetModel;
    });
    const requestedFinish = options && options.preserveFinish && options.finish
      ? normalizeFinishKey(options.finish)
      : '';
    const targetVariant = matchingVariants.find(function (variant) {
      return variant.available && requestedFinish && variant.finishKey === requestedFinish;
    }) || matchingVariants.find(function (variant) {
      return variant.available;
    }) || matchingVariants.find(function (variant) {
      if (variant.brand !== targetBrand || variant.model !== targetModel) return false;
      if (!requestedFinish) return true;
      return variant.finishKey === requestedFinish;
    }) || null;
    if (!targetVariant) return false;

    window.location.href = buildProductUrl(target.handle, {
      brand: targetBrand,
      model: targetModel,
      finish: targetVariant ? targetVariant.finishKey : '',
      variantId: targetVariant ? targetVariant.id : '',
      caseKey: caseKey,
      sourceContext: options && options.sourceContext ? options.sourceContext : 'custom-product-page',
      autoOpenPersonalize: Boolean(options && options.autoOpenPersonalize)
    });
    return true;
  }

  function buildProductUrl(handle, selection) {
    const url = new URL('/products/' + handle, window.location.origin);
    url.searchParams.set('view', 'gc-custom-personalize');
    if (selection.variantId) url.searchParams.set('variant', selection.variantId);
    if (selection.brand) url.searchParams.set('device', selection.brand);
    if (selection.model) url.searchParams.set('model', selection.model);
    if (selection.finish && selection.finish !== 'default') url.searchParams.set('finish', selection.finish);
    if (selection.caseKey) {
      url.searchParams.set('case', selection.caseKey);
      url.searchParams.set('case_key', selection.caseKey);
    }
    url.searchParams.set('from', selection.sourceContext || 'custom-product-page');
    if (selection.autoOpenPersonalize) url.searchParams.set(AUTO_OPEN_PARAM, '1');
    return url.toString();
  }

  function buildDesignYourOwnUrl(selection) {
    const url = new URL('/pages/design-your-own', window.location.origin);
    if (selection.brand) url.searchParams.set('device', selection.brand);
    if (selection.model) url.searchParams.set('model', selection.model);
    if (selection.finish && selection.finish !== 'default') url.searchParams.set('finish', selection.finish);
    if (selection.variantId) url.searchParams.set('variant', selection.variantId);
    if (selection.caseKey) {
      url.searchParams.set('case', selection.caseKey);
      url.searchParams.set('case_key', selection.caseKey);
    }
    url.searchParams.set('from', selection.sourceContext || 'custom-product-page');
    if (selection.edit) url.searchParams.set('edit', '1');
    return url.toString();
  }

  function getPersonalizeTargets(container) {
    if (!container) return [];
    return Array.from(container.querySelectorAll('button.personalize-button, [id^="personalize-button-"], a.personalize-button'))
      .filter(function (target) {
        return !target.closest('.personalize-modal') && !target.classList.contains('personalize-modal__close');
      });
  }

  function isPersonalizationModalRemoveIntentTarget(target) {
    if (!(target instanceof Element)) return false;
    if (!target.closest('.personalize-modal')) return false;

    const text = normalize(String(
      target.getAttribute('aria-label')
      || target.textContent
      || target.getAttribute('value')
      || ''
    )).toLowerCase();

    if (!text) return false;

    return /remove saved|remove design|delete design|clear design|remove image|clear image|remove photo|clear photo|start over|reset design|reset personalization|^remove$|^delete$|^clear$|^reset$/.test(text);
  }

  function isPersonalizationPageRemoveIntentTarget(target) {
    if (!(target instanceof Element)) return false;
    if (target.closest('.personalize-modal')) return false;

    const personalizeControl = target.closest('button.personalize-button, a.personalize-button, [id^="personalize-button-"]');
    if (!(personalizeControl instanceof Element)) return false;

    const text = normalize(String(
      personalizeControl.getAttribute('aria-label')
      || personalizeControl.textContent
      || personalizeControl.getAttribute('value')
      || ''
    )).toLowerCase();

    if (!text) return false;

    return /remove saved design|remove saved|remove design|clear design|start over|reset design|reset personalization/.test(text);
  }

  function setNativeSelectValue(select, targetValue, normalizeFn) {
    if (!select || !targetValue) return false;
    const normalizedTarget = normalizeFn(targetValue);
    const options = Array.from(select.options);
    const match = options.find(function (option) {
      return normalizeFn(option.textContent || option.value) === normalizedTarget;
    }) || options.find(function (option) {
      return normalizeFn(option.value) === normalizedTarget;
    });

    if (!match) return false;

    const changed = select.value !== match.value;
    select.value = match.value;
    select.selectedIndex = options.indexOf(match);
    return changed;
  }

  function dispatchNativeChange(element) {
    if (!element) return;
    element.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getSelectedText(select) {
    const option = select && select.selectedOptions && select.selectedOptions[0]
      ? select.selectedOptions[0]
      : null;
    return option ? option.textContent || option.value : select ? select.value : '';
  }

  function getCompareAtPrice(price, compareAt) {
    const numericPrice = Number(price || 0);
    const numericCompare = Number(compareAt || 0);
    return numericCompare > numericPrice ? numericCompare : 0;
  }

  function sortModels(models, brand) {
    const order = brand === 'samsung' ? SAMSUNG_ORDER : IPHONE_ORDER;
    return models.sort(function (left, right) {
      const leftIndex = order.indexOf(left);
      const rightIndex = order.indexOf(right);
      if (leftIndex !== -1 && rightIndex !== -1) return leftIndex - rightIndex;
      if (leftIndex !== -1) return -1;
      if (rightIndex !== -1) return 1;
      return left.localeCompare(right);
    });
  }

  function normalize(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function normalizeModel(value) {
    let model = normalize(value);
    if (!model) return '';

    if (/^iphone/i.test(model)) {
      model = model.replace(/^iphone\s*/i, 'iPhone ');
      return normalize(model);
    }

    model = model.replace(/^Samsung\s+Galaxy\s+/i, 'Samsung Galaxy ');
    model = model.replace(/^Samsung\s+S/i, 'Samsung Galaxy S');
    if (/^Galaxy\s+/i.test(model)) model = 'Samsung ' + model;
    if (/^S[0-9]{2}/i.test(model)) model = 'Samsung Galaxy ' + model.toUpperCase();
    return normalize(model);
  }

  function normalizeFinishKey(value) {
    const normalized = normalize(value).toLowerCase();
    if (!normalized) return 'default';
    if (normalized.includes('gloss')) return 'glossy';
    if (normalized.includes('matt')) return 'matte';
    if (normalized.includes('standard') || normalized.includes('default')) return 'default';
    return normalized.replace(/\s+/g, '_');
  }

  function normalizeBrand(value) {
    const normalized = normalize(value).toLowerCase();
    if (normalized === 'iphone' || normalized === 'ios') return 'iphone';
    if (normalized === 'samsung' || normalized === 'galaxy' || normalized === 'android') return 'samsung';
    return '';
  }

  function normalizeCaseKey(value) {
    const normalized = normalize(value).toLowerCase().replace(/-/g, '_');
    if (!normalized) return '';
    if (normalized === 'tough_case' || normalized === 'custom_tough_case') return 'tough_case';
    if (normalized === 'tough_magsafe' || normalized === 'tough_magsafe_case' || normalized === 'custom_tough_magsafe_case') return 'tough_magsafe_case';
    if (normalized === 'clear_magsafe' || normalized === 'clear_magsafe_case' || normalized === 'custom_clear_magsafe_case') return 'clear_magsafe_case';
    if (normalized === 'biodegradable' || normalized === 'biodegradable_case' || normalized === 'custom_biodegradable_case') return 'biodegradable_case';
    if (normalized === 'frosted_clear' || normalized === 'frosted_clear_case' || normalized === 'custom_frosted_clear_case' || normalized === 'samsung_clear' || normalized === 'samsung_clear_case' || normalized === 'clear_case') return 'frosted_clear_case';
    if (normalized === 'tough_magnetic' || normalized === 'tough_magnetic_case' || normalized === 'custom_tough_magnetic_case') return 'tough_magnetic_case';
    return '';
  }

  function getBrandForModel(model) {
    const normalized = normalize(model).toLowerCase();
    if (normalized.includes('samsung') || normalized.includes('galaxy')) return 'samsung';
    if (normalized.includes('iphone')) return 'iphone';
    return '';
  }

  function displayBrand(brand) {
    return brand === 'samsung' ? 'SAMSUNG' : brand === 'iphone' ? 'iPhone' : '--';
  }

  function formatMoney(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function parseJson(node) {
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function warmPersonalizeOrigin() {
    ensureResourceHint('dns-prefetch', '//personalize.at', 'gcp-dns-personalize');
    ensureResourceHint('preconnect', PERSONALIZE_ORIGIN, 'gcp-preconnect-personalize', true);
  }

  function ensureResourceHint(rel, href, key, crossOrigin) {
    if (!document.head || !href) return;
    const selector = `link[data-gcp-hint="${key}"]`;
    if (document.head.querySelector(selector)) return;

    const link = document.createElement('link');
    link.rel = rel;
    link.href = href;
    link.dataset.gcpHint = key;
    if (crossOrigin) link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  }

  function primePersonalizationPreview(previewUrl) {
    const normalizedPreviewUrl = String(previewUrl || '').trim();
    if (!normalizedPreviewUrl || !document.head) return;

    ensureResourceHint('preconnect', PERSONALIZE_ORIGIN, 'gcp-preconnect-personalize-preview', true);

    const image = new Image();
    image.decoding = 'async';
    image.loading = 'eager';
    image.fetchPriority = 'high';
    image.src = normalizedPreviewUrl;
    if (typeof image.decode === 'function') {
      image.decode().catch(function () {
        return;
      });
    }
  }

  function readBridgeState() {
    return null;
  }

  function isFreshBridgeState(bridgeState, currentHandle) {
    return false;
  }

  function clearBridgeState() {
    return;
  }

  function getPreviewStorageKey(handle) {
    return PREVIEW_STORAGE_PREFIX + String(handle || '');
  }

  function writePersonalizationPreview(storageKey, payload) {
    if (!storageKey || !payload || !payload.imageUrl) return;
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(payload));
    } catch (error) {
      return;
    }
  }

  function readPersonalizationPreview(storageKey) {
    if (!storageKey) return null;
    try {
      const raw = window.sessionStorage.getItem(storageKey);
      if (!raw) return null;
      const payload = JSON.parse(raw);
      if (!payload || !payload.imageUrl) return null;
      if (payload.updatedAt && (Date.now() - Number(payload.updatedAt)) > PREVIEW_TTL_MS) {
        window.sessionStorage.removeItem(storageKey);
        return null;
      }
      return payload;
    } catch (error) {
      return null;
    }
  }

  function clearPersonalizationPreview(storageKey) {
    if (!storageKey) return;
    try {
      window.sessionStorage.removeItem(storageKey);
    } catch (error) {
      return;
    }
  }

  function isPersonalizationRemovalMessage(message) {
    if (!message || typeof message !== 'object') return false;
    const type = String(message.type || '').toUpperCase();
    const action = String(message.action || (message.data && message.data.action) || '').toUpperCase();
    return /REMOVE|REMOVED|DELETE|DELETED|CLEAR|CLEARED|RESET/.test(type)
      || /REMOVE|REMOVED|DELETE|DELETED|CLEAR|CLEARED|RESET/.test(action);
  }

  function getPersonalizationPreviewUrl(message) {
    if (!message || message.type !== 'PERSONALIZATION_APPLIED') return '';
    const data = message.data && typeof message.data === 'object' ? message.data : null;
    if (!data || !data.imageUrl) return '';
    return String(data.imageUrl);
  }

  function getPersonalizationId(message) {
    if (!message || message.type !== 'PERSONALIZATION_APPLIED') return '';
    const data = message.data && typeof message.data === 'object' ? message.data : null;
    if (!data) return '';

    const personalizationId = data.personalizationId
      || data.designId
      || data.projectId
      || data.id;

    return personalizationId ? String(personalizationId) : '';
  }

  function applyPersonalizationPreview(root, previewUrl, altText, allowedIndices) {
    if (!root || !previewUrl) return false;

    primePersonalizationPreview(previewUrl);

    let updated = false;
    const mediaGallery = root.querySelector('media-gallery');
    const slides = mediaGallery
      ? Array.from(mediaGallery.querySelectorAll('.product-media-container'))
      : [];
    const thumbnailGroups = mediaGallery
      ? Array.from(mediaGallery.querySelectorAll('.slideshow-controls__thumbnails'))
      : [];
    const scopedIndices = allowedIndices instanceof Set && allowedIndices.size
      ? allowedIndices
      : new Set(slides.length ? [0] : []);
    const stickyImage = document.querySelector('.sticky-add-to-cart__image-img');

    slides.forEach(function (slide, index) {
      if (!scopedIndices.has(index)) return;
      updated = applyPreviewToContainer(slide, previewUrl, altText) || updated;
    });

    thumbnailGroups.forEach(function (group) {
      Array.from(group.children).forEach(function (thumbnail, index) {
        if (!scopedIndices.has(index)) return;
        updated = applyPreviewToContainer(thumbnail, previewUrl, altText) || updated;
      });
    });

    if (stickyImage instanceof HTMLImageElement) {
      updated = applyPreviewToImage(stickyImage, previewUrl, altText) || updated;
    }

    return updated;
  }

  function applyPreviewToContainer(container, previewUrl, altText) {
    if (!(container instanceof Element)) return false;

    let changed = false;
    container.querySelectorAll('source').forEach(function (source) {
      rememberOriginalAttribute(source, 'srcset');
      if (source.getAttribute('srcset') === previewUrl) return;
      source.setAttribute('srcset', previewUrl);
      changed = true;
    });

    container.querySelectorAll('img').forEach(function (image) {
      changed = applyPreviewToImage(image, previewUrl, altText) || changed;
    });

    return changed;
  }

  function applyPreviewToImage(image, previewUrl, altText) {
    if (!(image instanceof HTMLImageElement) || !previewUrl) return false;

    rememberOriginalAttribute(image, 'src');
    rememberOriginalAttribute(image, 'srcset');
    rememberOriginalAttribute(image, 'sizes');
    rememberOriginalAttribute(image, 'alt');

    const normalizedCurrent = normalizeImageUrl(image.getAttribute('src') || image.currentSrc || image.src || '');
    const normalizedPreview = normalizeImageUrl(previewUrl);
    const needsAlt = altText && image.getAttribute('alt') !== altText;
    const needsUpdate = normalizedCurrent !== normalizedPreview || image.getAttribute('srcset') || image.getAttribute('sizes') || needsAlt;

    if (!needsUpdate) return false;

    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.loading = 'eager';
    image.decoding = 'async';
    image.fetchPriority = 'high';
    image.setAttribute('src', previewUrl);
    image.src = previewUrl;
    if (altText) {
      image.setAttribute('alt', altText);
    }
    return true;
  }

  function getMobilePreviewHeaderOffset() {
    const bodyStyles = window.getComputedStyle(document.body);
    const rawHeaderHeight = parseFloat(bodyStyles.getPropertyValue('--header-group-height')) || 0;
    return Math.max(0, Math.min(140, rawHeaderHeight));
  }

  function scrollElementFullyIntoMobileViewport(element) {
    if (!(element instanceof HTMLElement)) return false;

    const rect = element.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    if (!viewportHeight) return false;

    const topBoundary = getMobilePreviewHeaderOffset() + MOBILE_PREVIEW_TOP_PADDING;
    const bottomBoundary = viewportHeight - MOBILE_PREVIEW_BOTTOM_PADDING;
    const availableHeight = Math.max(0, bottomBoundary - topBoundary);
    const currentScrollY = window.scrollY || window.pageYOffset || 0;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let targetScrollY = currentScrollY;

    if (rect.height > availableHeight && availableHeight > 0) {
      targetScrollY += rect.top - topBoundary;
    } else if (rect.bottom > bottomBoundary) {
      targetScrollY += rect.bottom - bottomBoundary;
    } else if (rect.top < topBoundary) {
      targetScrollY += rect.top - topBoundary;
    }

    targetScrollY = Math.max(0, targetScrollY);

    if (Math.abs(targetScrollY - currentScrollY) < 2) return false;

    window.scrollTo({
      top: targetScrollY,
      behavior: prefersReducedMotion ? 'auto' : 'smooth'
    });

    return true;
  }

  function restoreOriginalPersonalizationPreview(root, allowedIndices) {
    if (!root) return false;

    let updated = false;
    const mediaGallery = root.querySelector('media-gallery');
    const slides = mediaGallery
      ? Array.from(mediaGallery.querySelectorAll('.product-media-container'))
      : [];
    const thumbnailGroups = mediaGallery
      ? Array.from(mediaGallery.querySelectorAll('.slideshow-controls__thumbnails'))
      : [];
    const scopedIndices = allowedIndices instanceof Set && allowedIndices.size
      ? allowedIndices
      : new Set(slides.length ? [0] : []);
    const stickyImage = document.querySelector('.sticky-add-to-cart__image-img');

    slides.forEach(function (slide, index) {
      if (!scopedIndices.has(index)) return;
      updated = restoreOriginalContainer(slide) || updated;
    });

    thumbnailGroups.forEach(function (group) {
      Array.from(group.children).forEach(function (thumbnail, index) {
        if (!scopedIndices.has(index)) return;
        updated = restoreOriginalContainer(thumbnail) || updated;
      });
    });

    if (stickyImage instanceof HTMLImageElement) {
      updated = restoreOriginalImage(stickyImage) || updated;
    }

    return updated;
  }

  function restoreOriginalContainer(container) {
    if (!(container instanceof Element)) return false;

    let changed = false;
    container.querySelectorAll('source').forEach(function (source) {
      changed = restoreOriginalAttribute(source, 'srcset') || changed;
    });

    container.querySelectorAll('img').forEach(function (image) {
      changed = restoreOriginalImage(image) || changed;
    });

    return changed;
  }

  function restoreOriginalImage(image) {
    if (!(image instanceof HTMLImageElement)) return false;

    const srcChanged = restoreOriginalAttribute(image, 'src');
    const srcsetChanged = restoreOriginalAttribute(image, 'srcset');
    const sizesChanged = restoreOriginalAttribute(image, 'sizes');
    const altChanged = restoreOriginalAttribute(image, 'alt');

    if (srcChanged) {
      const restoredSrc = image.getAttribute('src');
      image.src = restoredSrc || '';
    }

    return srcChanged || srcsetChanged || sizesChanged || altChanged;
  }

  function rememberOriginalAttribute(element, attributeName) {
    if (!(element instanceof Element) || !attributeName) return;
    const dataAttribute = getOriginalAttributeKey(attributeName);
    if (element.hasAttribute(dataAttribute)) return;

    if (element.hasAttribute(attributeName)) {
      element.setAttribute(dataAttribute, element.getAttribute(attributeName) || ORIGINAL_MEDIA_EMPTY_VALUE);
      return;
    }

    element.setAttribute(dataAttribute, ORIGINAL_MEDIA_EMPTY_VALUE);
  }

  function restoreOriginalAttribute(element, attributeName) {
    if (!(element instanceof Element) || !attributeName) return false;
    const dataAttribute = getOriginalAttributeKey(attributeName);
    if (!element.hasAttribute(dataAttribute)) return false;

    const originalValue = element.getAttribute(dataAttribute);
    if (originalValue === ORIGINAL_MEDIA_EMPTY_VALUE) {
      if (!element.hasAttribute(attributeName)) return false;
      element.removeAttribute(attributeName);
      return true;
    }

    if (element.getAttribute(attributeName) === originalValue) return false;
    element.setAttribute(attributeName, originalValue);
    return true;
  }

  function getOriginalAttributeKey(attributeName) {
    return 'data-gcp-original-' + String(attributeName || '').toLowerCase();
  }

  function normalizeImageUrl(value) {
    const rawValue = String(value || '').trim();
    if (!rawValue) return '';

    try {
      const parsed = new URL(rawValue, window.location.origin);
      return parsed.host.toLowerCase() + parsed.pathname;
    } catch (error) {
      return rawValue.split('?')[0].replace(/^https?:/, '');
    }
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(String(value || ''));
    }

    return String(value || '').replace(/["\\\]]/g, '\\$&');
  }
})();
